var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Breadcrumb',{staticClass:"bread"},_vm._l((_vm.breadList),function(item,index){return _c('BreadcrumbItem',{key:index,attrs:{"to":{ path: item.path }}},[_vm._v(_vm._s(item.meta.title)+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }